/* eslint-disable class-methods-use-this */

export default class didomi {
  constructor() {
    // console.log('didomi init');
    this.init();
  }

  init() {
    window.didomiOnReady = window.didomiOnReady || [];
    window.didomiOnReady.push(function(Didomi) {
      const lang = document.querySelector('html').getAttribute('lang') || 'en';
      const preferencesDidomi = document.querySelector('#preferencesDidomi');
      const modalLogoDidomi = document.querySelector('.didomi-popup-notice-logo');

      if (preferencesDidomi && Didomi.isRegulationApplied('gdpr')) {
        preferencesDidomi.classList.remove('hidden');
      }

      if (modalLogoDidomi && Didomi.isRegulationApplied('gdpr')) {
        modalLogoDidomi.setAttribute('alt', lang === 'fr' ? 'Banque de l\'infrastructure du Canada (BIC)' : 'Canada Infrastructure Bank (CIB)');
      }

      if (Didomi.isConsentRequired()) {
        /* youtube */
        Didomi.getObservableOnUserConsentStatusForVendor('c:youtube').subscribe(function(consentStatusForVendor) {
          const elYoutubeIframes = document.querySelectorAll('[youtube-iframe]');
          let source = null;

          if (elYoutubeIframes.length > 0) {
            if (consentStatusForVendor) {
              elYoutubeIframes.forEach(iframe => {
                iframe.setAttribute('src', iframe.getAttribute('data-src'));
              });
            } else {
              elYoutubeIframes.forEach(iframe => {
                source = iframe.getAttribute('data-src').replace('youtube.com', 'youtube-nocookie.com');
                // console.log('source:', source);
                iframe.setAttribute('src', source);
              });
            }
          }
        });
      }
    });
  }
}
